import { apiClient } from '../client';
import { API_ENDPOINTS, CACHE_CONFIG } from '../config';

interface ProcedureSearchParams {
  q: string;
  category?: string;
  insuranceId?: string;
  page?: number;
  limit?: number;
}

interface ProcedurePricingParams {
  providerIds?: string[];
  insuranceId?: string;
}

class ProcedureService {
  async searchProcedures(params: ProcedureSearchParams) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });

    return apiClient.get(`${API_ENDPOINTS.procedures.search}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }

  async getProcedureDetail(procedureId: string) {
    return apiClient.get(API_ENDPOINTS.procedures.detail(procedureId), {
      cacheTTL: CACHE_CONFIG.staticDataTTL
    });
  }

  async getProcedurePricing(procedureId: string, params?: ProcedurePricingParams) {
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
          if (Array.isArray(value)) {
            value.forEach(v => queryParams.append(key, v));
          } else {
            queryParams.append(key, value.toString());
          }
        }
      });
    }

    return apiClient.get(`${API_ENDPOINTS.procedures.pricing(procedureId)}?${queryParams}`, {
      cacheTTL: CACHE_CONFIG.defaultTTL
    });
  }
}

export const procedureService = new ProcedureService();